import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpHeaders, HttpHeaderResponse, HttpRequest } from '@angular/common/http';
//import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/map';
import { map ,delay} from 'rxjs/operators';

import { AppGlobals } from '../shared/app.global';



  

@Injectable()
export class MasterService {

    callurl: string = '';
  
    clcd:string;
    aycd:string;
    usid:string;
    
        constructor(private http: HttpClient,private _global: AppGlobals) {
    
           this.clcd=localStorage.getItem('clcd');
           this.aycd=localStorage.getItem('aycd');
           this.usid=localStorage.getItem('usid');
         
           this.callurl=_global.baseAPIUrl;
         }

getcurenttime()
{
    debugger
    let timenow= new Date().toString().split(' ')[4];
    return timenow;
}
         getdatetoday()
         {
          let d: Date = new Date();
          var mnth;
          var day='';
          //let todayDate = {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()};
          if(d.getMonth()>=10)
          {
            mnth=d.getMonth()+1;
          }
          else{
           // mnth='0'+d.getMonth()+1;
           mnth=d.getMonth()+1;
           mnth='0'+mnth;
          }
       
          if(d.getDate()>=10)
          {
            day=d.getDate().toString();
          }
          else{
            day='0'+d.getDate();
          }
          let todayDate =  d.getFullYear()+'-'+ mnth+'-' +day;
            
       return todayDate;
       
         }

         getipurl(): any {
            debugger
            return this.http.get(this.callurl + 'getactiveip')
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
         }
         

         getpayipurl(): any {
            debugger
            return this.http.get(this.callurl + 'getpayip')
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data;
                    
                }));
         }
          masbloodgroups(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'masbloodgroup/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.masbloodgroup;
                    
                }));
          }


          selpreclasses(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'selpreclasses/'+this.clcd+'/'+this.aycd+'/'+this.usid)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.classlst;
                    
                }));
          }
          mascastecat(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'mascastecat/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.mascastecat;
                    
                }));
          }
          masacademicyear(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'masacademicyear/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.masacademicyear;
                    
                }));
          }
          massubcomb(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_exmsubcomb/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_exmsubcomb;
                    
                }));
          }

          mashouse(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_mashouse/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_mashouse;
                    
                }));
          }

          maspayopt(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_accpayoptions/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_accpayoptions;
                    
                }));
          }

          masfeequota(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_accfeequota/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_accfeequota;
                    
                }));
          }

          masmot(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_masmot/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_masmot;
                    
                }));
          }
          massection(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_massection/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_massection;
                    
                }));
          }
          mascourse(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'getmascourse/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.mascourse;
                    
                }));
          }
          masclass(): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'sel_sp_masclass/'+this.clcd+'/'+this.aycd)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_masclass;
                    
                }));
          }
          getcourse(): Observable<any> {

            var enqpost={clcd:this.clcd,aycd:this.aycd};
                
            //this.callurl='https://mycampuz.co.in/schoolpayment/admclasslist.php'
            
          
            // this.callurl=this.baseUrl+'Payenqrequest'
             return this.http.get(  this.callurl +"getmascourse/"+this.clcd+"/"+this.aycd )
                 .pipe(map((data: any) => 
                 {
                     console.log('clases',data);
                     return  data.mascourse ; 
                 }));
          } 
        
          classmasterrolewise(emid,roleid,clid,oprtype): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'selmasclassbyrole/'+this.clcd+'/'+this.aycd+'/'+emid+'/'+roleid+'/'+clid+'/'+oprtype)
            .pipe(
                map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_masclass;
                    
                })

                // map((data:any) => {
                //     data.sp_masclass.selected = false;
                //     // or via brackets
                //     // obj['total'] = 2;
                //     return data.sp_masclass;
                // })
                
                );
          }

          masperiod(clid): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'getmasperiod/'+this.clcd+'/'+this.aycd+'/'+clid)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.masperiod;
                    
                }));
          }

          sectionsrolewise(emid,roleid,clid,oprtype): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'selmassectionbyrole/'+this.clcd+'/'+this.aycd+'/'+emid+'/'+roleid+'/'+clid+'/'+oprtype)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_massection;
                    
                }));
          }

          getclasssection(classes: any): Observable<any> {
              debugger
           // secdata.clcd=this.clcd;
           // secdata.aycd=this.aycd;
            var pstdata={clcd:this.clcd,aycd:this.aycd,classes:classes};
              return this.http.post(this._global.baseAPIUrl + 'getclasssection', pstdata)
                  .pipe(map((data: any) => {
                      console.log('retres', data);
                      return data.sections;
                  }));
          }

          getstudentclasssecwise(classes: any): Observable<any> {
            debugger
         // secdata.clcd=this.clcd;
         // secdata.aycd=this.aycd;
          var pstdata={clcd:this.clcd,aycd:this.aycd,classes:classes};
            return this.http.post(this._global.baseAPIUrl + 'getstudentclasssecwise', pstdata)
                .pipe(map((data: any) => {
                    console.log('retres', data);
                    return data.stulst;
                }));
        }

        getstaffdeptwise(classes: any): Observable<any> {
            debugger
         // secdata.clcd=this.clcd;
         // secdata.aycd=this.aycd;
          var pstdata={clcd:this.clcd,aycd:this.aycd,depts:classes};
            return this.http.post(this._global.baseAPIUrl + 'getstaffdeptwise', pstdata)
                .pipe(map((data: any) => {
                    console.log('retres', data);
                    return data.emplst;
                }));
        }
          subjectsrolewise(emid,roleid,clid,oprtype): Observable<any> {
            debugger
            // let clcd=localStorage.getItem('clcd');
            // let aycd=localStorage.getItem('aycd');libsubjectgroup
            
            return this.http.get(this.callurl + 'selsubjectsbyrole/'+this.clcd+'/'+this.aycd+'/'+emid+'/'+roleid+'/'+clid+'/'+oprtype)
            .pipe(map((data: any) => {
                    console.log('retres-data', data);
                    return data.sp_massubjects;
                    
                }));
          }

          sel_sp_massubgp() {
            let clcd=this.clcd;
            let aycd=this.aycd;
            return this.http.get(this._global.baseAPIUrl + 'sel_sp_massubgp/'+clcd+'/'+aycd)
                .pipe(map((data: any) => {
                    return data.sp_massubgp;
                }));
        }

        masacyear() {
            let clcd=this.clcd;
            let aycd=this.aycd;
            return this.http.get(this._global.baseAPIUrl + 'masacyear/'+clcd+'/'+aycd)
                .pipe(map((data: any) => {
                    return data.aylist;
                }));
        }
        save_sp_massubgp(secdata: any): Observable<any> {

            secdata.clcd=this.clcd;
            secdata.aycd=this.aycd;
            return this.http.post(this._global.baseAPIUrl + 'save_sp_massubgp', secdata)
                .pipe(map((data: any) => {
                    console.log('retres', 'response');
                    return data
                }));
        }

        sel_sp_massubcat() {

          let clcd=this.clcd;
            let aycd=this.aycd;
          return this.http.get(this._global.baseAPIUrl + 'sel_sp_massubcat/'+clcd+'/'+aycd)
              .pipe(map((data: any) => {
                  return data.sp_massubcat;
              }));
      }
      save_sp_massubcat(secdata: any): Observable<any> {
        secdata.clcd=this.clcd;
        secdata.aycd=this.aycd;
          return this.http.post(this._global.baseAPIUrl + 'save_sp_massubcat', secdata)
              .pipe(map((data: any) => {
                  console.log('retres', 'response');
                  return data
              }));
      }
  

      sel_sp_massubjects() {
        let clcd=localStorage.getItem('clcd');
        let aycd=localStorage.getItem('aycd');
        return this.http.get(this._global.baseAPIUrl + 'sel_sp_massubjects/'+clcd+'/'+aycd)
            .pipe(map((data: any) => {
                return data.sp_massubjects;
            }));
    }
    save_sp_massubjects(secdata: any): Observable<any> {
        secdata.clcd=this.clcd;
        secdata.aycd=this.aycd;
        return this.http.post(this._global.baseAPIUrl + 'save_sp_massubjects', secdata)
            .pipe(map((data: any) => {
                console.log('retres', 'response');
                return data
            }));
    }


    sel_sp_exmsubcomb() {
      let clcd=localStorage.getItem('clcd');
      let aycd=localStorage.getItem('aycd');
      return this.http.get(this._global.baseAPIUrl + 'sel_sp_exmsubcomb/'+clcd+'/'+aycd)
          .pipe(map((data: any) => {
              return data.sp_exmsubcomb;
          }));
  }
  save_sp_exmsubcomb(secdata: any): Observable<any> {
    secdata.clcd=this.clcd;
    secdata.aycd=this.aycd;
      return this.http.post(this._global.baseAPIUrl + 'save_sp_exmsubcomb', secdata)
          .pipe(map((data: any) => {
              console.log('retres', 'response');
              return data
          }));
  }

  sel_sp_masasshead() {

    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'sel_sp_masasshead/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            return data.sp_masasshead;
        }))
}

sel_sp_masasstype() {
    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'sel_sp_masasstype/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            return data.sp_masasstype;
        }))
}
masclasssubject(clssubdata: any): Observable<any> {
    return this.http.post(this._global.baseAPIUrl + 'by_sp_masclasssubject', clssubdata)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data
        }));
}
save_sp_masasshead(secdata: any): Observable<any> {
    return this.http.post(this._global.baseAPIUrl + 'save_sp_masasshead', secdata)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data
        }));
}

save_sp_masclasssubject(clsdata: any): Observable<any> {
    clsdata.clcd=this.clcd;
    clsdata.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'save_sp_masclasssubject', clsdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
}

saveclassdtls(clsdata: any): Observable<any> {
    clsdata.clcd=this.clcd;
    clsdata.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'save_sp_masclass', clsdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
}

savemascourse(clsdata: any): Observable<any> {
    clsdata.clcd=this.clcd;
    clsdata.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'save_mascourse', clsdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
}

savesection(clsdata: any): Observable<any> {
    clsdata.clcd=this.clcd;
    clsdata.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'save_sp_massection', clsdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
}

sel_sp_masoccation() {
    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'sel_sp_masoccation/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            return data.sp_masoccation;
        }))
}
save_sp_masoccation(secdata: any): Observable<any> {
    return this.http.post(this._global.baseAPIUrl + 'save_sp_masoccation', secdata)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data
        }));
}

sel_sp_hrmdesig() {
    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'sel_sp_hrmdesig/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            return data.sp_hrmdesig;
        }))
}

Save_hrmdesig(rd) {
    let clcd=this.clcd;
    let aycd=this.aycd;
    var pdata={clcd:this.clcd,aycd:this.aycd,desid:rd.desid,desnm:rd.desnm,descd:rd.descd,sort:rd.sort,crby:this.usid,mdby:this.usid,oprtag:rd.oprtag};
    return this.http.post(this._global.baseAPIUrl + 'save_sp_hrmdesig',pdata)
        .pipe(map((data: any) => {
            console.log('dept',data);
            return data;
        }))
}


get_hrmdept() {
    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'sel_sp_hrmdept/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            console.log('dept',data);
            return data.sp_hrmdept;
        }))
}

delhrmdesig(desid) {
    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'delhrmdesig/'+clcd+'/'+aycd+'/'+desid)
        .pipe(map((data: any) => {
            console.log('dept',data);
            return data;
        }))
}

delhrmdept(depid) {
    let clcd=this.clcd;
    let aycd=this.aycd;
    return this.http.get(this._global.baseAPIUrl + 'delhrmdept/'+clcd+'/'+aycd+'/'+depid)
        .pipe(map((data: any) => {
            console.log('dept',data);
            return data;
        }))
}


Save_hrdept(rd) {
    let clcd=this.clcd;
    let aycd=this.aycd;
    var pdata={clcd:this.clcd,aycd:this.aycd,depid:rd.depid,depnm:rd.depnm,depcd:rd.depcd,sort:rd.sort,crby:this.usid,mdby:this.usid,oprtag:rd.oprtag};
    return this.http.post(this._global.baseAPIUrl + 'save_sp_hrmdept',pdata)
        .pipe(map((data: any) => {
            console.log('dept',data);
            return data;
        }))
}

getacfeechart(oprtype: any,sertxt): Observable<any> {
    debugger
    var pstdata={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,sertxt:sertxt};
    return this.http.post(this._global.baseAPIUrl + 'getacfeechart', pstdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data.feelist
        }));
}

getacfeechartdet(objdet:any): Observable<any> {
    //var pstdata={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,sertxt:sertxt};
    objdet.clcd=this.clcd;
    objdet.aycd=this.aycd;
    objdet.usid=this.usid;
    objdet.oprtype='seldet';
    return this.http.post(this._global.baseAPIUrl + 'getacfeechartdet', objdet)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data.feelistdet
        }));
}


getacchead(acstatus) {
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    return this.http.get(this._global.baseAPIUrl + 'sel_sp_accaccounthead/'+clcd+'/'+aycd+'/'+acstatus)
        .pipe(map((data: any) => {
            return data.accheadlist;
        }));
}





saveacfeechart(objdet:any): Observable<any> {
    //var pstdata={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,sertxt:sertxt};
    objdet.clcd=this.clcd;
    objdet.aycd=this.aycd;
    objdet.usid=this.usid;
    //objdet.oprtype='seldet';
    return this.http.post(this._global.baseAPIUrl + 'saveacfeechart', objdet)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data
        }));
}

delacfeechart(rid:any): Observable<any> {
    var pstdata={clcd:this.clcd,aycd:this.aycd,rid:rid};
    // objdet.clcd=this.clcd;
    // objdet.aycd=this.aycd;
    // objdet.usid=this.usid;
    //objdet.oprtype='seldet';
    return this.http.post(this._global.baseAPIUrl + 'delacfeechart', pstdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data
        }));
}

getinstallment() {
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    return this.http.get(this._global.baseAPIUrl + 'sel_sp_accinstallment/'+clcd+'/'+aycd)
        .pipe(map((data: any) => {
            return data.sp_accinstallments;
        }));
}


masinstallment(): Observable<any> {
    debugger
    // let clcd=localStorage.getItem('clcd');
    // let aycd=localStorage.getItem('aycd');libsubjectgroup
    
    return this.http.get(this.callurl + 'sel_sp_accinstallment/'+this.clcd+'/'+this.aycd)
    .pipe(map((data: any) => {
            console.log('masinsta-data', data);
            return data.sp_accinstallments;
            
        }));
  }
  
  
  saveinstadtls(instadata: any): Observable<any> {
    debugger
    instadata.clcd=this.clcd;
    instadata.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'save_sp_accinstallment', instadata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
  }

// FeeQuta Service

masfeequta(): Observable<any> {
    debugger
  
    return this.http.get(this.callurl + 'sel_sp_accfeequota/'+this.clcd+'/'+this.aycd)
    .pipe(map((data: any) => {
            console.log('masfeequota', data);
            return data.sp_accfeequota;
            
        }));
  }

  savefeqdetails(feqtadata: any): Observable<any> {
    debugger
    feqtadata.clcd=this.clcd;
    feqtadata.aycd=this.aycd;
    return this.http.post(this._global.baseAPIUrl + 'save_sp_accfeequota', feqtadata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
  }

// Accounts Head Service
masacchead(status): Observable<any> {
    debugger

    return this.http.get(this.callurl + 'sel_sp_accaccounthead/'+this.clcd+'/'+this.aycd+'/'+status)
    .pipe(map((data: any) => {
            console.log('masacchead', data);
            return data.accheadlist;
            
        }));
  }


  saveaachdetails(acchdata: any): Observable<any> {
    debugger
    acchdata.clcd=this.clcd;
    acchdata.aycd=this.aycd;
    acchdata.usid=this.usid;
    console.log('data', acchdata);
    return this.http.post(this._global.baseAPIUrl + 'save_sp_accaccounthead', acchdata)
        .pipe(map((data: any) => {
         
            console.log('retres ACH', data);
            return data;
        }));
  }


  //Account Cat
  masacccat(): Observable<any> {
    debugger

    return this.http.get(this.callurl + 'sel_sp_acccat/'+this.clcd+'/'+this.aycd)
    .pipe(map((data: any) => {
            console.log('masacchead', data);
            return data.sp_acccat;
            
        }));
  }

  savecatadtls(accatdata:any):Observable<any> {
    debugger
    accatdata.clcd=this.clcd;
    accatdata.aycd=this.aycd;
    accatdata.usid=this.usid;
    console.log('data',accatdata);
    return this.http.post(this._global.baseAPIUrl + 'save_sp_acccat',accatdata)
    .pipe(map((data:any)=>{
        console.log('data',data);
        return data;
    }));
}

//Payment Option

maspayop(): Observable<any> {
    debugger

    return this.http.get(this.callurl + 'sel_sp_accpayoptions/'+this.clcd+'/'+this.aycd)
    .pipe(map((data: any) => {
            console.log('maspayop', data);
            return data.sp_accpayoptions;
            
        }));
  }


  savepayop(payop:any):Observable<any> {
    debugger
    payop.clcd=this.clcd;
    payop.aycd=this.aycd;
    payop.usid=this.usid;
    console.log('data',payop);
    return this.http.post(this._global.baseAPIUrl + 'save_sp_accpayoptions',payop)
    .pipe(map((data:any)=>{
        console.log('data',data);
        return data;
    }));
}

// mot 

masmotransaction(): Observable<any> {
    debugger

    return this.http.get(this.callurl + 'sel_sp_accmot/'+this.clcd+'/'+this.aycd)
    .pipe(map((data: any) => {
            console.log('maspayop', data);
            return data.sp_accmmot;
            
        }));
  }

  savemot(mot:any):Observable<any> {
    debugger
    mot.clcd=this.clcd;
    mot.aycd=this.aycd;
    mot.usid=this.usid;
    console.log('data',mot);
    return this.http.post(this._global.baseAPIUrl + 'save_sp_mot',mot)
    .pipe(map((data:any)=>{
        console.log('data',data);
        return data;
    }));
}

getstudent(clid:number,secid:number,brid:string): Observable<any> {
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    return this.http.get(this._global.baseAPIUrl + 'sp_student/'+clid+'/'+secid+'/dbnm/'+clcd+'/'+aycd+'/'+brid)
        .pipe(map((data: any) => {
            console.log('retres', 'response');
            return data.by_sp_clsSec;
        }));
}

getmasmtongue(): Observable<any> {
    debugger
    // let clcd=localStorage.getItem('clcd');
    // let aycd=localStorage.getItem('aycd');libsubjectgroup
    
    return this.http.get(this.callurl + 'getmothertongue/'+this.clcd+'/'+this.aycd)
    .pipe(map((data: any) => {
            console.log('retres-data', data);
            return data.motlst;
            
        }));
  }


  masgeneral(tag): Observable<any> {
    debugger
    // let clcd=localStorage.getItem('clcd');
    // let aycd=localStorage.getItem('aycd');libsubjectgroup
    
    return this.http.get(this.callurl + 'getmasgeneral/'+this.clcd+'/'+this.aycd+'/'+tag)
    .pipe(map((data: any) => {
            console.log('retres-data', data);
            return data.masgeneralst;
            
        }));
  }


  getusefullink(): Observable<any> {
    debugger
   
    
    return this.http.get(this.callurl + 'getusefullink/'+this.clcd+'/'+this.aycd)
    .pipe(map((data: any) => {
            console.log('getusefullink', data);
            return data.arrlinks;
            
        }));
  }


  

}